import { assertNever } from '@kofno/piper';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import Main from '../BrowserSupport/Main';
import CenteredLogo from '../components/CenteredLogo';
import WithBackgroundImage from '../components/WithBackgroundImage';
import { Anonymous, Unauthorized, type Errored } from '../CurrentUserStore/Types';
import Title from '../Title';
import { T } from '../Translations';
import Action from './Action';
import CurrentUserErrorMessage from './CurrentUserErrorMessage';
import { savePreAuthenticationDestination } from './Destination';
import ErrorMessage from './ErrorMessage';
import LoginReactions from './Reactions';
import { LoginStore } from './Store';

interface Props {
  currentUserState: Anonymous | Unauthorized | Errored;
}

class Login extends React.Component<Props> {
  store = new LoginStore();

  componentDidMount(): void {
    switch (this.props.currentUserState.kind) {
      case 'anonymous':
        savePreAuthenticationDestination();
        this.store.redirecting();
        break;
      case 'errored':
      case 'unauthorized':
        break;
      default:
        assertNever(this.props.currentUserState);
    }
  }

  render() {
    return (
      <>
        <LoginReactions store={this.store} fireImmediately />
        <WithBackgroundImage>
          <Main>
            <div
              className={clsx(
                'mx-auto w-92.5 items-center justify-center',
                'rounded-md bg-white px-6 pt-8 shadow lg:w-96',
              )}
            >
              <div className={clsx('place-items-center p-2')}>
                <Title title="Login" />
                <ErrorMessage store={this.store} />
                <CurrentUserErrorMessage state={this.props.currentUserState} />
                <CenteredLogo />
                <Heading currentUserState={this.props.currentUserState} />
                <p className="my-3">
                  <T kind="Your Client Portal account is accessed via your Platform account." />
                </p>
                <p className="my-3">
                  <T kind="You will automatically be returned to the Client Portal once you are signed in to your Platform account." />
                </p>
                <div className="my-8">
                  <Action currentUserState={this.props.currentUserState} />
                </div>
              </div>
            </div>
          </Main>
        </WithBackgroundImage>
      </>
    );
  }
}

function Heading({ currentUserState }: Props) {
  switch (currentUserState.kind) {
    case 'anonymous':
      return (
        <h1 className={clsx('text-slate-dark my-10 text-xl font-medium')} data-test-title={true}>
          <T kind="Logging you in..." />
        </h1>
      );
    case 'unauthorized':
    case 'errored':
      return <></>;
  }
}

export default observer(Login);
